const c = "container_zIcwi", o = "checkbox_FwYEY", r = "error_lAqpU", e = {
  container: c,
  checkbox: o,
  error: r
};
export {
  o as checkbox,
  c as container,
  e as default,
  r as error
};
//# sourceMappingURL=checkbox.module.scss.js.map
